import styled, { css } from 'styled-components'

import { Reset, TransitionPrimary } from '@/lib/mixins'

export const TaxIdModalWrapper = styled.div``

export const TaxIdModalTitle = styled.h3`
  margin: 0 0 3.25rem;
  text-align: center;
  font-size: 2.25rem;
  line-height: 1.1;
`

export const TaxIdFormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem 1.25rem;
`

export const InvoiceTypeToggle = styled.div`
  display: flex;
  justify-content: center;
  gap: 2.5rem;
  margin-bottom: 2.25rem;
  border-bottom: 1px solid ${props => props.theme.color.line};

  ${props =>
    props.theme.accessibilityMode &&
    css`
      flex-direction: column;
      gap: 0;
      border-bottom: 0;
    `}
`

export const InvoiceTypeTab = styled.button<{ $active?: boolean }>`
  ${Reset('button')}
  ${TransitionPrimary('color')}
  position: relative;
  min-height: 3.5rem;
  padding: 1rem 0.5rem;
  font-family: ${props => props.theme.font.primary};
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.15;
  white-space: nowrap;
  color: ${props => props.theme.color.muted};

  &:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 3px;
    background-color: ${props => props.theme.color.secondary};
    transform: scaleX(0);
    visibility: hidden;
    opacity: 0;
    ${TransitionPrimary('transform, opacity, visibility')}
  }

  ${props =>
    props.$active &&
    css`
      color: ${props => props.theme.color.primary};
      font-weight: 600;

      &:after {
        transform: scaleX(1);
        visibility: visible;
        opacity: 1;
      }
    `}

  ${props =>
    props.theme.accessibilityMode &&
    css`
      width: 100%;
      text-align: left;
      padding: 1.25rem 1rem;
      border: 1px solid ${props => props.theme.color.line};

      &:not(:last-child) {
        border-bottom: 0;
      }

      &:after {
        left: 0;
        top: 0;
        bottom: 0;
        right: auto;
        width: 4px;
        height: auto;
      }
    `}
`

export const VatLookupCell = styled.div`
  display: flex;
  align-items: center;

  button {
    width: 100%;
  }
`

export const VatLookupMessage = styled.p<{ $variant: 'error' | 'warning' | 'info' }>`
  grid-column: 1 / -1;
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.3;
  color: ${({ theme, $variant }) => ($variant === 'info' ? theme.color.global : theme.color.red)};
`

export const TaxIdActions = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 20rem));
  justify-content: center;
  gap: 1.25rem;
  margin-top: 2.25rem;

  button {
    width: 100%;
  }
`
